import React, { useState } from 'react'
import { Download } from 'lucide-react'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
// import { ExportOptions } from '../types'

interface ExportPanelProps {
  canvasRef: React.RefObject<HTMLDivElement>
  onClose: () => void
  title?: string
  watermark?: string
}

export const ExportPanel: React.FC<ExportPanelProps> = ({ canvasRef, onClose, title: _title, watermark: _watermark }) => {
  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)

  const handleExport = async () => {
    if (!canvasRef.current) {
      alert('画布未准备好，请稍后再试')
      return
    }
    setIsExporting(true)
    setExportProgress(0)
    // 导出前加exporting类，隐藏export-hide元素
    canvasRef.current.classList.add('exporting')
    try {
      const progressInterval = setInterval(() => {
        setExportProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval)
            return 90
          }
          return prev + 10
        })
      }, 100)
      const rect = canvasRef.current.getBoundingClientRect()
      const canvas = await html2canvas(canvasRef.current, {
        backgroundColor: '#ffffff',
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
      })
      clearInterval(progressInterval)
      setExportProgress(100)
      canvas.toBlob((blob) => {
        if (blob) {
          const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
          const filename = `comic-strip-${timestamp}.png`
          saveAs(blob, filename)
        }
      }, 'image/png')
      setTimeout(() => {
        setIsExporting(false)
        setExportProgress(0)
        // 导出后移除exporting类
        canvasRef.current && canvasRef.current.classList.remove('exporting')
        onClose()
      }, 1000)
    } catch (error) {
      console.error('导出失败:', error)
      alert('导出失败，请重试')
      setIsExporting(false)
      setExportProgress(0)
      // 导出失败也要移除exporting类
      canvasRef.current && canvasRef.current.classList.remove('exporting')
    }
  }

  return (
    <div className="floating-panel" style={{ minWidth: '350px' }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gradient">导出图片</h3>
        <button
          onClick={onClose}
          className="w-6 h-6 hover:bg-gray-100 rounded-full flex items-center justify-center"
        >
          ×
        </button>
      </div>
      <div className="space-y-4">
        <div className="pt-4 border-t">
          {isExporting ? (
            <div className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span>导出中...</span>
                <span>{exportProgress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-primary-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${exportProgress}%` }}
                />
              </div>
            </div>
          ) : (
            <button
              onClick={handleExport}
              className="w-full glass-button flex items-center justify-center space-x-2 py-3"
            >
              <Download size={20} />
              <span>导出条漫</span>
            </button>
          )}
        </div>
        <div className="text-xs text-gray-500 space-y-1">
          <p>• 导出的图片将保存到您的下载文件夹</p>
          <p>• 导出尺寸与实际条漫画布一致</p>
          <p>• 建议使用PNG格式以获得最佳质量</p>
        </div>
      </div>
    </div>
  )
} 